import { Formik, Field, ErrorMessage, Form as FormikForm } from 'formik'
import I18n from 'i18n-js'
import PropTypes from 'prop-types'
import { Fragment } from 'react'
import styled from 'styled-components'

import Breakpoints from '../../../lib/Breakpoints'
import colors from '../../../lib/Colors'
import yup from '../../../lib/YupValidations'

const StyledForm = styled(FormikForm)`
  display: flex;
  flex-direction: column;
`

const StyledField = styled(Field)`
  border: none;
  border-bottom: 1px solid ${colors.gray_light};
  transition: border-bottom 0.3s ease-in-out;
  background: ${colors.white};
  &:focus,
  &:active {
    border-bottom: 1px solid ${colors.promoboxx_blue};
  }
  & + label,
  & + button,
  & + div {
    /* ErrorMessage.marginBottom + ErrorMessage.marginTop + ErrorMessage.font-size*/
    margin-top: 26px;
  }
`

const StyledErrorMessage = styled(ErrorMessage)`
  margin: 2px 0 8px;
  font-size: 14px;
  color: red;
`

const StyledButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  & > button:not(:last-child),
  & > a:not(:last-child) {
    margin-bottom: 15px;
    @media (min-width: ${Breakpoints.phone}) {
      margin-bottom: 0;
    }
  }
  @media (min-width: ${Breakpoints.phone}) {
    justify-content: space-between;
    flex-direction: row;
  }
`

const Form = (props) => {
  let validationSchema = yup.object().shape(
    props.fields.reduce((obj, item) => {
      if (item.validation) {
        item.validation._label = item.label || I18n.t('validations.thisField')
        obj[item.name] = item.validation
      }
      return obj
    }, {}),
  )

  return (
    <Formik
      onSubmit={(values) => props.onSubmit(values)}
      validationSchema={validationSchema}
    >
      <StyledForm className={props.className} id={props.id} name={props.name}>
        {props.fields.map((field) => {
          return (
            <Fragment key={field.label}>
              {field.component === 'select' && (
                <StyledField
                  component="select"
                  data-testid={`${field.name}Input`}
                  id={field.id}
                  name={field.name}
                  validate={field.validate}
                  value={field.value}
                >
                  {field.options.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.name}
                    </option>
                  ))}
                </StyledField>
              )}
              {field.component !== 'select' && (
                <StyledField
                  component={field.component}
                  data-testid={`${field.name}Input`}
                  id={field.id}
                  label={field.label}
                  multiline={field.multiline}
                  name={field.name}
                  type={field.type}
                  validate={field.validate}
                  value={field.value}
                />
              )}
              <StyledErrorMessage component="span" name={field.name} />
            </Fragment>
          )
        })}
        <StyledButtonWrapper>{props.children}</StyledButtonWrapper>
      </StyledForm>
    </Formik>
  )
}

Form.propTypes = {
  children: PropTypes.any,
  className: PropTypes.any,
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      component: PropTypes.oneOf(['input', 'select', 'textarea']),
      options: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string.isRequired,
          value: PropTypes.any.isRequired,
        }),
      ),
      placeholder: PropTypes.string,
    }),
  ).isRequired,
  onSubmit: PropTypes.func,
}

export default Form
